import React from "react";
import { Interrogator, QuestionsObj } from "ewoq/containers/Interrogator";
import questions from "./Questions/SleepAssessmentQuestions";
import { answerQuestionnaire } from "ewoq/api";

interface Props {
  onDone?: () => void;
  viewAll?: boolean;
  name?: string;
}

class SleepAssessment extends React.Component<Props> {
  onSubmit = (answers: QuestionsObj) => {
    answerQuestionnaire(
      "REB",
      this.props.name + "-SleepReport-SleepAssessment",
      {
        answers: answers
      }
    ); //RestTest?

    this.props.onDone && this.props.onDone();
  };

  render() {
    return (
      <div>
        <Interrogator
          questions={questions}
          onDone={this.onSubmit}
          viewAll={this.props.viewAll}
        />
      </div>
    );
  }
}

export default SleepAssessment;
